var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 17.5C81.1046 17.5 82 16.6046 82 15.5C82 14.3954 81.1046 13.5 80 13.5V17.5ZM0.585786 14.0858C-0.195262 14.8668 -0.195262 16.1332 0.585786 16.9142L13.3137 29.6421C14.0948 30.4232 15.3611 30.4232 16.1421 29.6421C16.9232 28.8611 16.9232 27.5948 16.1421 26.8137L4.82843 15.5L16.1421 4.18629C16.9232 3.40524 16.9232 2.13891 16.1421 1.35786C15.3611 0.576816 14.0948 0.576816 13.3137 1.35786L0.585786 14.0858ZM80 13.5H2V17.5H80V13.5Z",
    fill: "#009BF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/PreviousArrow.d849d48cfead612520ed3557aa89eec0.svg";
export { ForwardRef as ReactComponent };